import { useEffect, useRef, useState } from 'react';
import { NIcon } from '@nemo/react';
import { useMixpanelContext } from '../../providers/MixpanelContext';
import { Tutor } from '../../utils/types';
import { sessionScriptSrcByEnv, tutorPortalUrl } from '../../utils/utils';
import Avatar from './Avatar';
import { ReactComponent as CaretDown } from '../../assets/image/caret-down.svg';

interface AvatarPillProps {
  tutor: Tutor;
}

function AvatarPill({ tutor }: AvatarPillProps) {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [isOptionsOpen, setIsOptionsOpen] = useState<boolean>(false);

  const { mixpanelTrackEvent } = useMixpanelContext();

  const togglePillOptions = () => {
    setIsOptionsOpen((prev) => !prev);
  };

  const closeDropdown = () => {
    setIsOptionsOpen(false);
  };

  const onOpenTutorSurvey = () => {
    // Mixpanel metric tutor redirect to survey:
    mixpanelTrackEvent('TutorPortalRedirectToMondlyTutorSurvey', {
      tutor,
    });
    window.open('https://tinyurl.com/mondlytutorsurvey', '_blank');
    closeDropdown();
  };

  const onLogout = () => {
    window.piSession?.logout();
    // Mixpanel metric tutor logout:
    mixpanelTrackEvent('TutorPortalLogout', {
      tutor,
    });
    setTimeout(() => {
      window.location.replace(
        `https://iam-stage.pearson.com/auth/oauth2/realms/pearson/authorize?service=AuthN&client_id=${sessionScriptSrcByEnv()}&&scope=openid&response_type=code&redirect_uri=${tutorPortalUrl()}`,
      );
    }, 2 * 1000);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        closeDropdown();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="avatar-pill-container" ref={dropdownRef}>
      <button
        type="button"
        className={`avatar-pill-btn ${isOptionsOpen ? 'open' : ''}`}
        onClick={() => togglePillOptions()}
      >
        <Avatar firstName={tutor.firstName} lastName={tutor.lastName} thumb={tutor.thumb} />
        <div className="tutor-name">{`${tutor.firstName} ${tutor.lastName}`}</div>
        <div className={`caret ${isOptionsOpen ? 'open' : ''}`}>
          <CaretDown />
        </div>
      </button>
      {isOptionsOpen && (
        <div className="dropdown-menu">
          <button type="button" className="dropdown-item" onClick={() => onOpenTutorSurvey()}>
            <NIcon size="md" name="chat-circle-dots" />
            Share your feedback
          </button>
          <button type="button" className="dropdown-item" onClick={() => onLogout()}>
            <NIcon size="md" name="sign-out" />
            Logout
          </button>
        </div>
      )}
    </div>
  );
}

export default AvatarPill;
